import { createAction } from '@reduxjs/toolkit';
import type { UIState } from './state';

export enum UIActionType {
    SET_UI_STATE = 'SET_UI_STATE',
}

export const setUIState = createAction<UIState>(UIActionType.SET_UI_STATE);
